import React from 'react';
import { ClockIcon, ShieldIcon, CheckIcon, DownloadIcon, TruckIcon, BookIcon } from 'lucide-react';
export const CallToAction = () => {
  return <section id="order" className="py-12 sm:py-16 bg-white" data-id="element-35">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
        <div className="text-center" data-id="element-37">
          <h2 className="text-2xl font-extrabold text-gray-900 sm:text-3xl md:text-4xl" data-id="element-38">
            <span className="block" data-id="element-39">Get your copy today</span>
            <span className="block text-[#990000]" data-id="element-40">
              Create a legacy your family will cherish forever
            </span>
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-base sm:text-lg text-gray-500" data-id="element-41">
            Choose the format that works best for your family. All options
            include our legacy guarantee.
          </p>
        </div>
        <div className="mt-8 sm:mt-12 space-y-8 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-x-8" data-id="element-42">
          {/* Digital Copy */}
          <div className="relative p-6 sm:p-8 bg-white border border-gray-200 rounded-2xl shadow-sm flex flex-col" data-id="element-43">
            <div className="flex-1" data-id="element-44">
              <h3 className="text-xl font-semibold text-gray-900" data-id="element-45">
                Digital Copy
              </h3>
              <p className="absolute top-0 -translate-y-1/2 bg-[#0A2463] text-white px-3 py-0.5 text-sm font-semibold rounded-full" data-id="element-46">
                Instant Access
              </p>
              <div className="mt-4 flex items-baseline text-gray-900" data-id="element-47">
                <span className="text-4xl sm:text-5xl font-extrabold tracking-tight" data-id="element-48">
                  $19.97
                </span>
                <span className="ml-1 text-lg sm:text-xl line-through text-gray-500" data-id="element-49">
                  $47.97
                </span>
              </div>
              <p className="mt-4 sm:mt-6 text-sm sm:text-base text-gray-500" data-id="element-50">
                Instant digital access to preserve your family's values.
              </p>
              {/* Digital Book Image */}
              <div className="mt-4 flex justify-center" data-id="element-51">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sAAoHE4hW1VPNqwfNtn4wA/digitalremem.png" alt="Digital Edition" className="h-auto w-full max-w-xs mx-auto object-contain rounded-md shadow-md sm:max-w-sm md:max-w-md" data-id="element-52" />
              </div>
              {/* Feature List */}
              <ul className="mt-4 sm:mt-6 space-y-3 sm:space-y-4" data-id="element-53">
                <li className="flex" data-id="element-54">
                  <DownloadIcon className="flex-shrink-0 h-5 w-5 sm:h-6 sm:w-6 text-[#0A2463]" data-id="element-55" />
                  <span className="ml-3 text-sm sm:text-base text-gray-500" data-id="element-56">
                    Instant Download
                  </span>
                </li>
                <li className="flex" data-id="element-57">
                  <CheckIcon className="flex-shrink-0 h-5 w-5 sm:h-6 sm:w-6 text-[#0A2463]" data-id="element-58" />
                  <span className="ml-3 text-sm sm:text-base text-gray-500" data-id="element-59">
                    Includes 1 FREE Bonus!
                  </span>
                </li>
                <li className="flex" data-id="element-60">
                  <CheckIcon className="flex-shrink-0 h-5 w-5 sm:h-6 sm:w-6 text-[#0A2463]" data-id="element-61" />
                  <span className="ml-3 text-sm sm:text-base text-gray-500" data-id="element-62">
                    Read on any device
                  </span>
                </li>
              </ul>
            </div>
            <a href="https://www.voicesoffreedomus.com/cart/45185635680442:1" className="mt-6 sm:mt-8 block w-full bg-[#0A2463] border border-transparent rounded-md py-3 sm:py-4 px-8 sm:px-10 text-center font-medium text-white hover:bg-[#081c4e]" data-id="element-63">
              Get Digital Copy Now
            </a>
          </div>
          {/* Physical Copy */}
          <div className="relative p-6 sm:p-8 bg-white border-2 border-[#990000] rounded-2xl shadow-lg flex flex-col" data-id="element-64">
            <div className="flex-1" data-id="element-65">
              <h3 className="text-xl font-semibold text-gray-900" data-id="element-66">
                Physical Copy
              </h3>
              <p className="absolute top-0 -translate-y-1/2 bg-[#990000] text-white px-3 py-0.5 text-sm font-semibold rounded-full" data-id="element-67">
                Most Popular
              </p>
              <div className="mt-4 flex items-baseline text-gray-900" data-id="element-68">
                <span className="text-4xl sm:text-5xl font-extrabold tracking-tight" data-id="element-69">
                  $34.97
                </span>
                <span className="ml-1 text-lg sm:text-xl line-through text-gray-500" data-id="element-70">
                  $67.97
                </span>
              </div>
              <p className="mt-4 sm:mt-6 text-sm sm:text-base text-gray-500" data-id="element-71">
                The physical keepsake your family will cherish for generations.
              </p>
              {/* Physical Book Image */}
              <div className="mt-4 flex justify-center" data-id="element-72">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jUbfg1ijMbax1eNECEEH8R/Generated_Image_September_25%2C_2025_-_3_46PM.png" alt="Physical Copy Edition" className="h-auto w-full max-w-xs mx-auto object-contain rounded-md shadow-md sm:max-w-sm md:max-w-md" data-id="element-73" />
              </div>
              {/* Feature List */}
              <ul className="mt-4 sm:mt-6 space-y-3 sm:space-y-4" data-id="element-74">
                <li className="flex" data-id="element-75">
                  <BookIcon className="flex-shrink-0 h-5 w-5 sm:h-6 sm:w-6 text-[#990000]" data-id="element-76" />
                  <span className="ml-3 text-sm sm:text-base text-gray-500" data-id="element-77">
                    Premium Softcover Edition
                  </span>
                </li>
                <li className="flex" data-id="element-78">
                  <TruckIcon className="flex-shrink-0 h-5 w-5 sm:h-6 sm:w-6 text-[#990000]" data-id="element-79" />
                  <span className="ml-3 text-sm sm:text-base text-gray-500" data-id="element-80">
                    Shipping: 14 days (high demand)
                  </span>
                </li>
                <li className="flex" data-id="element-81">
                  <CheckIcon className="flex-shrink-0 h-5 w-5 sm:h-6 sm:w-6 text-[#990000]" data-id="element-82" />
                  <span className="ml-3 font-medium text-sm sm:text-base text-gray-900" data-id="element-83">
                    Includes 3 FREE Bonuses!
                  </span>
                </li>
              </ul>
            </div>
            <a href="https://www.voicesoffreedomus.com/cart/45185632403642:1" className="mt-6 sm:mt-8 block w-full bg-[#990000] border border-transparent rounded-md py-3 sm:py-4 px-8 sm:px-10 text-center font-medium text-white hover:bg-[#7A0000]" data-id="element-84">
              Order Physical Copy
            </a>
          </div>
          {/* Premium Edition */}
          <div className="relative p-6 sm:p-8 bg-white border border-gray-200 rounded-2xl shadow-sm flex flex-col" data-id="element-85">
            <div className="flex-1" data-id="element-86">
              <h3 className="text-xl font-semibold text-gray-900" data-id="element-87">
                Premium Hardcover
              </h3>
              <p className="absolute top-0 -translate-y-1/2 bg-[#DAA520] text-white px-3 py-0.5 text-sm font-semibold rounded-full" data-id="element-88">
                PREMIUM
              </p>
              <div className="mt-4 flex items-baseline text-gray-900" data-id="element-89">
                <span className="text-4xl sm:text-5xl font-extrabold tracking-tight" data-id="element-90">
                  $94.97
                </span>
                <span className="ml-1 text-lg sm:text-xl line-through text-gray-500" data-id="element-91">
                  $127.97
                </span>
              </div>
              <p className="mt-4 sm:mt-6 text-sm sm:text-base text-gray-500" data-id="element-92">
                Heirloom-quality edition designed to last for generations.
              </p>
              {/* Premium Book Image */}
              <div className="mt-4 flex justify-center" data-id="element-93">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1ZoNDNqCvi6bzsic1oPEch/hcremem.png" alt="Premium Hardcover Edition" className="h-auto w-full max-w-xs mx-auto object-contain rounded-md shadow-md sm:max-w-sm md:max-w-md" data-id="element-94" />
              </div>
              {/* Feature List */}
              <ul className="mt-4 sm:mt-6 space-y-3 sm:space-y-4" data-id="element-95">
                <li className="flex" data-id="element-96">
                  <BookIcon className="flex-shrink-0 h-5 w-5 sm:h-6 sm:w-6 text-[#DAA520]" data-id="element-97" />
                  <span className="ml-3 text-sm sm:text-base text-gray-500" data-id="element-98">
                    Luxurious Hardcover Edition
                  </span>
                </li>
                <li className="flex" data-id="element-99">
                  <TruckIcon className="flex-shrink-0 h-5 w-5 sm:h-6 sm:w-6 text-[#DAA520]" data-id="element-100" />
                  <span className="ml-3 text-sm sm:text-base text-gray-500" data-id="element-101">
                    Shipping: 14 days (high demand)
                  </span>
                </li>
                <li className="flex" data-id="element-102">
                  <CheckIcon className="flex-shrink-0 h-5 w-5 sm:h-6 sm:w-6 text-[#DAA520]" data-id="element-103" />
                  <span className="ml-3 font-medium text-sm sm:text-base text-gray-900" data-id="element-104">
                    Includes 3 digital FREE Bonuses!
                  </span>
                </li>
              </ul>
            </div>
            <a href="https://www.voicesoffreedomus.com/cart/45185628766394:1" className="mt-6 sm:mt-8 block w-full bg-gradient-to-r from-[#DAA520] to-[#CD7F32] border border-transparent rounded-md py-3 sm:py-4 px-8 sm:px-10 text-center font-medium text-white hover:from-[#B8860B] hover:to-[#A0522D]" data-id="element-105">
              Order Premium Edition
            </a>
          </div>
        </div>
        <div className="mt-8 sm:mt-12 bg-gray-50 rounded-lg px-4 sm:px-6 py-6 sm:py-8" data-id="element-106">
          <div className="flex items-center mb-4" data-id="element-107">
            <ShieldIcon className="h-5 w-5 text-[#990000]" data-id="element-108" />
            <h3 className="ml-2 text-base sm:text-lg leading-6 font-medium text-gray-900" data-id="element-109">
              Limited Edition Keepsake
            </h3>
          </div>
          <p className="text-sm sm:text-base text-gray-500" data-id="element-110">
            Once these copies are gone, they won't return. Secure yours now to
            ensure your family has this gift for generations to come.
          </p>
          <div className="mt-6 border-t border-gray-200 pt-6" data-id="element-111">
            <div className="flex items-center mb-4" data-id="element-112">
              <ClockIcon className="h-5 w-5 text-[#990000]" data-id="element-113" />
              <h3 className="ml-2 text-base sm:text-lg leading-6 font-medium text-gray-900" data-id="element-114">
                Your family's future — preserved
              </h3>
            </div>
            <p className="text-sm sm:text-base text-gray-500" data-id="element-115">
              Your story, your values, your family's future — all preserved in
              one powerful keepsake. Let this book be the bridge between today's
              faith and tomorrow's future.
            </p>
          </div>
        </div>
      </div>
    </section>;
};